import React, { useState, useEffect } from "react";
import { List as ListIcon, MoreVertical, Pencil, Trash2, X, Eye, GripVertical, Circle, CheckCircle, ChevronDown, StopCircle, Pause, Play } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { useSidebar } from "../../SidebarContext";
import TaskModal from "./TaskModal";
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import TaskHistory from "./TaskHistory";
import { decryptToken } from "../utils/getToken";
import { toast } from "react-toastify";
import TaskModalEdit from "./TaskModalEdit";
import Swal from "sweetalert2";

const Task = () => {
    const { isSidebarOpen } = useSidebar();
    const [menuOpen, setMenuOpen] = useState(false);
    const [listSectionOpen, setListSectionOpen] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [availableColors, setAvailableColors] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);
    const [listName, setListName] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [priorityFilter, setPriorityFilter] = useState("");
    const [selectedTask, setSelectedTask] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [completedOpen, setCompletedOpen] = useState(false);
    const [activeListId, setActiveListId] = useState(null);
    const [assignOptions, setAssignOptions] = useState([]);
    const [leadOptions, setLeadOptions] = useState([])
    const [taskEdit, setTaskEdit] = useState()

    const [editList, setEditList] = useState(null); // null = create, object = edit


    const url = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""


    // store lists in state so we can add to them
    const [lists, setLists] = useState([
        // { id: 1, name: "Work", color: "#3b82f6" },
        // { id: 2, name: "Personal", color: "#ef4444" },
        // { id: 3, name: "Groceries", color: "#10b981" },
        // { id: 4, name: "Projects", color: "#f59e0b" },
    ]);

    const [tasks, setTasks] = useState([
        // {
        //     id: 1,
        //     title: "Design Landing Page",
        //     priority: "High",
        //     dueDate: "2025-08-16",
        //     repetition: "Does not repeat",
        //     assignTo: "John Doe",
        //     addToList: "Work",
        //     notes: "Design the landing page mockups.",
        //     attachment: "landing_page.pdf",
        //     status: "open",
        //     completed: true,
        //     paused: false,
        //     history: [
        //         {
        //             event: "completed",
        //             timestamp: "2025-08-15T10:00:00Z",
        //             reason: null,
        //         },
        //     ],
        // },

    ]);


    // parent component scope must have setTasks, setSelectedTask
    const updateTaskField = async (taskId, field, value) => {
        try {
            // optimistic update
            setTasks(prev => prev.map(t => t.id === taskId ? { ...t, [field]: value } : t));

            let res, data;
            if (field === "attachment" && value instanceof File) {
                const formData = new FormData();
                formData.append("attachment", value);
                res = await fetch(`${url}/task/updatetask/${taskId}`, {
                    method: "PATCH",
                    body: formData,
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                res = await fetch(`${url}/task/stafftask/${taskId}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ [field]: value }),
                });
            }
            // fetchTask();
            data = await res.json();

            // compute actual updates returned by server (fallback to optimistic)
            const serverUpdates = data?.updates ?? (data?.attachment ? { attachment: data.attachment } : { [field]: value });

            // apply server-confirmed updates to tasks
            setTasks(prev => prev.map(t => t.id === taskId ? { ...t, ...serverUpdates } : t));

            // **CRITICAL** — keep selectedTask in sync if it's the one being edited
            setSelectedTask(prev => prev && prev.id === taskId ? { ...prev, ...serverUpdates } : prev);

        } catch (err) {
            console.error("Update failed", err);
            // optionally rollback optimistic change or refetch the single task
        }
    };



    const handleCompleteTask = async (id, taskStatus) => {
        try {
            const response = await fetch(`${url}/task-history/staffhistory`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    title: taskStatus === "Completed" ? "In Progress" : "Completed",

                    task_id: id
                })
            })
            if (response.ok) {
                ChangeTaskCompletion(id, taskStatus)

                toast.success(`Task ${taskStatus === "Completed" ? "In Progress" : "Completed"}`)
            }
        } catch (error) {
            toast.error(`${error.message}`)
        }
        // setTasks((prev) =>
        //     prev.map((task) => {
        //         if (task.id === id) {
        //             const newCompletedState = !task.completed;
        //             const newHistory = [
        //                 ...task.history,
        //                 {
        //                     event: newCompletedState ? "completed" : "uncompleted",
        //                     timestamp: new Date().toISOString(),
        //                     reason: null,
        //                 },
        //             ];
        //             return { ...task, completed: newCompletedState, history: newHistory };
        //         }
        //         return task;
        //     })
        // );
    };


    const ChangeTaskCompletion = async (id, taskStatus) => {
        try {
            const response = await fetch(`${url}/task/changetask/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    status: taskStatus === "Completed" ? "In Progress" : "Completed",
                })

            })
            const res = await response.json();
            if (response.ok) {
                fetchTask();
                // toast.success("Task Completed")
            } else {
                toast.error(`${res.message}`)
            }
        } catch (error) {
            toast.error(error.message)
            console.log(error)
        }
    }


    const fetchTask = async () => {
        try {
            const response = await fetch(`${url}/task/stafftask`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
            });

            const res = await response.json();
            console.log(res);
            if (response.ok) {
                let tasks = [...res.data];

                // ✅ If tasks have a `position` field, sort by it
                if (tasks.some(task => task.position !== undefined && task.position !== null)) {
                    tasks.sort((a, b) => (a.position ?? Infinity) - (b.position ?? Infinity));
                }

                setTasks(tasks);
            } else {
                toast.error(res.error || "Failed to fetch tasks");
            }
        } catch (error) {
            toast.error(error.message);
        }
    };



    const filteredTasks = tasks.filter(
        (t) =>
            (statusFilter ? t.status === statusFilter : true) &&
            (priorityFilter ? t.priority.toLowerCase() === priorityFilter : true)
    );

    const activeTasks = filteredTasks.filter((t) => t.status !== "Completed");
    const completedTasks = filteredTasks.filter((t) => t.status === "Completed");


    const getRandomColor = () => {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };

    useEffect(() => {
        if (popupOpen) {
            let colors = [];
            while (colors.length < 3) {
                let newColor = getRandomColor();
                if (
                    !colors.includes(newColor) &&
                    !lists.some((list) => list.color === newColor)
                ) {
                    colors.push(newColor);
                }
            }

            // Ensure edit color stays in list
            if (editList && editList.list_color && !colors.includes(editList.list_color)) {
                colors[0] = editList.list_color; // replace one with existing color
            }

            setAvailableColors(colors);
        }
    }, [popupOpen, lists, editList]);


    const handleCreateList = async () => {
        if (!listName.trim() || !selectedColor) return;

        const payload = {
            list_name: listName.trim(),
            list_color: selectedColor,
        };

        try {
            if (editList) {
                const response = await fetch(`${url}/task-list/edit-list/${editList.id}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                });
                const res = await response.json();

                if (response.ok) {
                    toast.success(`${res.message}`);

                    setLists((prev) =>
                        prev.map((l) => (l.id === editList.id ? { ...l, ...payload } : l))
                    );
                    setPopupOpen(false);
                    setEditList(null);
                } else {
                    toast.error(`${res.message}`);
                }
            } else {
                // ---- Create Mode ----
                const response = await fetch(`${url}/task-list/createlist`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                });
                const res = await response.json();

                if (response.ok) {
                    toast.success(`${res.message}`);
                    setLists((prev) => [
                        ...prev,
                        { ...payload, id: res.data } // merge with local object
                    ]);
                    setPopupOpen(false);
                } else {
                    toast.error(`${res.message}`);
                }
            }

            setListName("");
            setSelectedColor(null);
        } catch (error) {
            toast.error(error.message);
        }
    };


    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5, // drag starts after moving 5px (helps prevent accidental drags on click)
            },
        })
    );

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active.id !== over?.id) {
            setTasks((tasks) => {
                const oldIndex = tasks.findIndex((t) => t.id === active.id);
                const newIndex = tasks.findIndex((t) => t.id === over.id);
                const newTasks = arrayMove(tasks, oldIndex, newIndex);

                // update backend with new positions
                updateTaskOrder(newTasks);

                return newTasks;
            });
        }
    };

    const updateTaskOrder = async (tasks) => {
        try {
            const orderedTasks = tasks.map((t, index) => ({
                id: t.id,        // id stays SAME
                position: index, // just update position
            }));

            await fetch(`${url}/task/reorder`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ orderedTasks }),
            });
        } catch (error) {
            console.error("Failed to update order:", error);
        }
    };



    const handleTogglePause = async (taskId, taskpause, reason = null) => {
        try {
            const response = await fetch(`${url}/task-history/staffhistory`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    title: taskpause ? "Paused" : "Continue Task",
                    notes: reason,
                    task_id: taskId
                })
            })
            if (response.ok) {
                taskUpdatePause(taskId, taskpause)
                // fetchTask();
                toast.success(`Task ${taskpause ? "Paused" : "Continue Task"}`);
            }
        } catch (error) {
            toast.error(`${error.message}`)
        }
        // setTasks((prev) =>
        //     prev.map((t) => {
        //         if (t.id === taskId) {
        //             const newPausedState = !t.paused;
        //             const newHistory = [
        //                 ...t.history,
        //                 {
        //                     event: newPausedState ? "pause" : "play",
        //                     timestamp: new Date().toISOString(),
        //                     reason: newPausedState ? reason : null,
        //                 },
        //             ];
        //             return { ...t, paused: newPausedState, pauseReason: reason, history: newHistory };
        //         }
        //         return t;
        //     })
        // );
    };

    const taskUpdatePause = async (taskId, taskpause) => {
        try {
            const response = await fetch(`${url}/task/changetask/${taskId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    paused: taskpause ? false : true
                })
            })
            const res = await response.json()
            if (response.ok) {
                fetchTask();
            }

        } catch (error) {
            console.log(error)
        }
    }
    const handleDeleteListTask = async (LeadId) => {
        try {
            const response = await fetch(`${url}/task-list/delete-list/${LeadId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();
            if (response.ok) {
                toast.success(`${res.message}`)
                setLists((prev) => prev.filter((l) => l.id !== LeadId))
            } else {
                toast.error(`${res.message}`)
            }
        } catch (error) {
            toast.error(`${error.message}`)
        }
    }


    const fetchTaskList = async () => {
        try {
            const response = await fetch(`${url}/task-list/stafflistdata`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
            const res = await response.json();

            if (response.ok) {
                setLists(res.data);
                const options = res.data.map(task => ({
                    label: task.list_name,
                    value: task.id,
                    color: task.list_color
                }));
                setLeadOptions(options);
            } else {
                toast.error(`${res.error}`)
            }
        } catch (error) {
            console.log(error)
            toast.error(`${error.message}`)
        }
    }


    // const fetchDataEmployee = async () => {
    //     try {
    //         const response = await fetch(`${url}/staff`, {
    //             method: "GET",
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });
    //         const res = await response.json();
    //         if (response.ok) {
    //             const options = res.map((task) => ({
    //                 label:
    //                     task.lastName +
    //                     " " +
    //                     task.firstName +
    //                     " (" +
    //                     task.emplyee_ID +
    //                     ")",
    //                 value: task.id,
    //             }));

    //             setAssignOptions(options);
    //         }
    //     } catch (error) {
    //         toast.error(`${error.message}`);
    //     }
    // };


    const handleDeleteTask = async (taskId) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "This action cannot be undone!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel"
            });

            if (result.isConfirmed) {
                const res = await fetch(`${url}/task/${taskId}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.ok) {
                    Swal.fire("Deleted!", "Task has been deleted.", "success");
                    // ✅ remove from state instantly
                    setTasks((prev) => prev.filter((t) => t.id !== taskId));
                } else {
                    const err = await res.json();
                    Swal.fire("Error!", err.message || "Failed to delete task", "error");
                }
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error!", "Something went wrong!", "error");
        }
    };

    // useEffect(() => {
    //     fetchDataEmployee();
    // }, []);



    useEffect(() => {
        fetchTaskList();
        fetchTask();
    }, [])

    useEffect(() => {
        if (editList) {
            setListName(editList.list_name || "");
            setSelectedColor(editList.list_color || null);
        } else {
            setListName("");
            setSelectedColor(null);
        }
    }, [editList, popupOpen]);



    return (
        <>
            <div className={`open-close ${isSidebarOpen ? "open" : "closed"}`}>
                {/* Header */}
                <div className="flex items-center justify-between">
                    <h1 className="dashboard-title">Tasks</h1>
                    <div className="flex items-center gap-3 relative">
                        <button
                            onClick={() => setListSectionOpen((prev) => !prev)}
                            className="oms-add-btn"
                        >
                            <span>List</span>
                            <ListIcon className="w-4 h-4" />
                        </button>
                        <button
                            className="p-2 rounded-full hover:bg-gray-100 transition"
                            onClick={() => setMenuOpen((prev) => !prev)}
                        >
                            <MoreVertical className="w-5 h-5 text-gray-700" />
                        </button>
                        <AnimatePresence>
                            {menuOpen && (
                                <motion.div
                                    initial={{ opacity: 0, y: -8 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0, y: -8 }}
                                    className="absolute right-0 top-full mt-2 w-44 bg-white shadow-xl rounded-lg overflow-hidden z-50 border border-gray-100"
                                >
                                    {["Export XLSX", "Export CSV", "Import", "Analytics"].map(
                                        (item) => (
                                            <button
                                                key={item}
                                                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                                            >
                                                {item}
                                            </button>
                                        )
                                    )}
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>

                {/* List Section */}
                <AnimatePresence>
                    {listSectionOpen && (
                        <motion.div
                            initial={{ opacity: 0, height: 0 }}
                            animate={{ opacity: 1, height: "auto" }}
                            exit={{ opacity: 0, height: 0 }}
                            className="p-2 bg-white shadow-sm rounded-lg mt-4 border border-gray-200"
                        >
                            <div className="flex items-center justify-between mb-2 pb-2 border-b border-gray-200">
                                <h2 className="text-md font-semibold text-gray-700">Lists</h2>
                                <button
                                    onClick={() => {
                                        setEditList(null)
                                        setListName("");
                                        setSelectedColor(null);
                                        setPopupOpen(true)

                                    }}
                                    className="flex items-center gap-2 underline cursor-pointer mr-1 font-semibold"
                                >
                                    Create new list
                                </button>
                            </div>
                            <div className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide">
                                {lists.map((list) => (
                                    <div
                                        key={list.id}
                                        className="flex items-center gap-2 px-3 py-2 bg-white shadow-sm rounded-full whitespace-nowrap hover:shadow-md transition"
                                    >
                                        {/* Left side: color + name */}
                                        <div className="flex items-center gap-2">
                                            <div
                                                className="w-6 h-6 rounded-full"
                                                style={{ backgroundColor: list.list_color }}
                                            />
                                            <span className="text-sm font-medium text-gray-700">
                                                {list.list_name}
                                            </span>
                                        </div>

                                        {/* Expanded actions when menuOpen */}
                                        <AnimatePresence>
                                            {activeListId === list.id && (
                                                <motion.div
                                                    initial={{ opacity: 0, x: 10 }}
                                                    animate={{ opacity: 1, x: 0 }}
                                                    exit={{ opacity: 0, x: 10 }}
                                                    className="flex items-center gap-2 ml-3"
                                                >
                                                    <button
                                                        onClick={() => {
                                                            setEditList(list);
                                                            setPopupOpen(true);
                                                        }}
                                                        className="flex items-center gap-1 px-2 py-1 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                                                    >
                                                        <Pencil className="w-4 h-4" /> Edit
                                                    </button>
                                                    <button
                                                        onClick={() =>
                                                            handleDeleteListTask(list.id)
                                                        }
                                                        className="flex items-center gap-1 px-2 py-1 text-sm text-red-600 bg-red-100 rounded-lg hover:bg-red-200 transition"
                                                    >
                                                        <Trash2 className="w-4 h-4" /> Delete
                                                    </button>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>

                                        {/* Right side: kebab or X */}
                                        <button
                                            className="p-1 rounded-full hover:bg-gray-100"
                                            onClick={() =>
                                                setActiveListId((prev) => (prev === list.id ? null : list.id))
                                            }
                                        >
                                            {activeListId === list.id ? (
                                                <X className="w-4 h-4 text-gray-600" />
                                            ) : (
                                                <MoreVertical className="w-4 h-4 text-gray-600" />
                                            )}
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>

                {/* Popup */}
                <AnimatePresence>
                    {popupOpen && (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50"
                        >
                            <motion.div
                                initial={{ scale: 0.9 }}
                                animate={{ scale: 1 }}
                                exit={{ scale: 0.9 }}
                                className="bg-white w-full max-w-md rounded-2xl shadow-2xl p-6"
                            >
                                <h3 className="text-lg font-semibold mb-4">Create New List</h3>
                                <label className="block text-sm font-medium mb-1">List Name</label>
                                <input
                                    type="text"
                                    value={listName}
                                    onChange={(e) => setListName(e.target.value)}
                                    placeholder="Enter list name"
                                    className="w-full border rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:ring-1 focus:ring-blue-500"
                                />
                                <label className="block text-sm font-medium mb-2">Choose a color</label>
                                <div className="flex items-center gap-3 mb-6">


                                    {availableColors.map((color) => (
                                        <button
                                            key={color}
                                            onClick={() => setSelectedColor(color)}
                                            className={`w-8 h-8 rounded-full border transition ${selectedColor === color
                                                ? "ring-2 ring-offset-2 ring-blue-500"
                                                : "hover:ring-2 hover:ring-offset-1"
                                                }`}
                                            style={{ backgroundColor: color }}
                                        />
                                    ))}


                                    <input
                                        type="color"
                                        className="w-8 h-8 rounded-full border p-0 cursor-pointer"
                                        title="Custom Color"
                                        onChange={(e) => setSelectedColor(e.target.value)}
                                    />
                                </div>
                                <div className="flex justify-end gap-3">
                                    <button
                                        onClick={() => setPopupOpen(false)}
                                        className="px-4 py-2 text-sm bg-gray-200 rounded-lg hover:bg-gray-300"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleCreateList}
                                        className="px-4 py-2 text-sm bg-blue-500 text-white rounded-lg hover:bg-blue-600 shadow-md"
                                    >
                                        Create
                                    </button>
                                </div>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>

                <div className="flex justify-center items-start gap-2  mt-4">
                    <div className="space-y-2 p-2 bg-white shadow rounded-md border border-gray-200 flex-[2] w-full text-xs md:text-[13px]">
                        {/* Filters + New Task */}
                        <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                            <div className="flex flex-wrap gap-2">
                                {/* Status Filter */}
                                <select
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                    className="border rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                    <option value="">Select Status</option>
                                    {/* <option value="open">Open</option> */}
                                    <option value="Open">In Progress</option>
                                    <option value="Completed">Completed</option>
                                </select>

                                {/* Priority Filter */}
                                <select
                                    value={priorityFilter}
                                    onChange={(e) => setPriorityFilter(e.target.value)}
                                    className="border rounded-md px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
                                >
                                    <option value="">Select Priority</option>
                                    <option value="high">High</option>
                                    <option value="medium">Medium</option>
                                    <option value="low">Low</option>
                                </select>
                            </div>

                            {/* New Task Button */}
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="flex items-center gap-1 underline cursor-pointer font-semibold text-sm"
                            >
                                Create new task
                            </button>
                        </div>

                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                            <SortableContext items={filteredTasks.map((t) => t.id)} strategy={verticalListSortingStrategy}>
                                <div className="space-y-1">
                                    {/* Active Tasks Heading */}
                                    <div className="text-sm font-semibold text-gray-700 mb-2">
                                        Active Tasks ({activeTasks.length})
                                    </div>

                                    {/* Active Tasks */}
                                    {activeTasks.map((task) => (
                                        <SortableTask
                                            key={task.id}
                                            task={task}
                                            handleCompleteTask={handleCompleteTask}
                                            onEdit={() => {
                                                setIsModalOpen1(true)
                                                setTaskEdit(task)
                                            }}
                                            onDelete={(id) => handleDeleteTask(task.id)}
                                            onView={(task) => setSelectedTask(task)}
                                            onClick={() => setSelectedTask(task)}
                                            onTogglePause={handleTogglePause}
                                        />
                                    ))}
                                    {activeTasks.length === 0 && (
                                        <div className="text-center text-gray-400 py-3 italic text-xs">
                                            No active tasks
                                        </div>
                                    )}

                                    {/* Completed Accordion */}
                                    {completedTasks.length > 0 && (
                                        <div className="mt-3 pt-2">
                                            <button
                                                onClick={() => setCompletedOpen((prev) => !prev)}
                                                className="flex items-center justify-between w-full text-sm font-medium text-gray-700 hover:text-gray-900"
                                            >
                                                <span>Completed ({completedTasks.length})</span>
                                                <motion.span
                                                    animate={{ rotate: completedOpen ? 180 : 0 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <ChevronDown className="w-4 h-4" />
                                                </motion.span>
                                            </button>

                                            <AnimatePresence>
                                                {completedOpen && (
                                                    <motion.div
                                                        initial={{ opacity: 0, height: 0 }}
                                                        animate={{ opacity: 1, height: "auto" }}
                                                        exit={{ opacity: 0, height: 0 }}
                                                        className="mt-2 space-y-1"
                                                    >
                                                        {completedTasks.map((task) => (
                                                            <SortableTask
                                                                key={task.id}
                                                                task={task}
                                                                handleCompleteTask={handleCompleteTask}
                                                                onEdit={() => {
                                                                    setIsModalOpen1(true)
                                                                    setTaskEdit(task)
                                                                }}
                                                                onDelete={(id) =>
                                                                    handleDeleteTask(task.id)
                                                                }
                                                                onView={(task) => setSelectedTask(task)}
                                                                onClick={() => setSelectedTask(task)}
                                                                onTogglePause={handleTogglePause}
                                                            />
                                                        ))}
                                                    </motion.div>
                                                )}
                                            </AnimatePresence>
                                        </div>
                                    )}
                                </div>

                            </SortableContext>
                        </DndContext>

                    </div>

                    {/* Slide-in Task Details */}
                    <AnimatePresence>
                        {selectedTask && (
                            <motion.div
                                initial={{ x: "100%" }}
                                animate={{ x: 0 }}
                                exit={{ x: "100%" }}
                                transition={{ type: "tween", duration: 0.3 }}
                                className={`
        w-full md:w-auto
        p-2 bg-white shadow rounded-lg border border-gray-200
        flex-1
        md:relative
        fixed inset-y-0 top-16 right-0 z-50 overflow-y-auto
        md:overflow-visible
        md:translate-x-0
        md:top-0
        md:z-0
      `}
                            >
                                {/* Header */}
                                <div className="flex justify-between items-center mb-4 border-b border-gray-200 pb-2">
                                    <h2 className="text-md font-semibold text-gray-700">Task Details</h2>
                                    {/* Close button only visible on mobile */}
                                    <button onClick={() => setSelectedTask(null)}>
                                        <X size={20} className="text-gray-700" />
                                    </button>
                                </div>

                                {/* Task Info */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-black">
                                    <div>
                                        <p className="font-medium">Title</p>
                                        <EditableField
                                            value={selectedTask.title}
                                            field="title"
                                            onChange={(val) => updateTaskField(selectedTask.id, "title", val)}
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div>
                                        <p className="font-medium">Due Date</p>
                                        <EditableField
                                            value={selectedTask.due_date}
                                            field="due_date"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "due_date", val)
                                            }
                                            // onChange={(newValue) => updateTask(task.id, { title: newValue })}
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div>
                                        <p className="font-medium">Repetition</p>
                                        <EditableField
                                            value={selectedTask.repetition}
                                            field="repetition"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "repetition", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div>
                                        <p className="font-medium">Priority</p>
                                        <EditableField
                                            value={selectedTask.priority}
                                            field="priority"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "priority", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                        />
                                    </div>

                                    <div>
                                        <p className="font-medium">Assign To</p>
                                        <EditableField
                                            value={selectedTask.assign_to}
                                            field="assign_to"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "assign_to", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div>
                                        <p className="font-medium">Add to List</p>
                                        <EditableField
                                            value={selectedTask.list_id}
                                            field="list_id"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "list_id", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div className="col-span-1 md:col-span-2">
                                        <p className="font-medium">Notes</p>
                                        <EditableField
                                            value={selectedTask.notes}
                                            field="notes"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "notes", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>

                                    <div className="col-span-1 md:col-span-2">
                                        <p className="font-medium">Attachment</p>
                                        <EditableField
                                            value={selectedTask.attachment}
                                            field="attachment"
                                            onChange={(val) =>
                                                updateTaskField(selectedTask.id, "attachment", val)
                                            }
                                            leadOptions={leadOptions}
                                            assignOptions={assignOptions}
                                            assignedBy={selectedTask.assigned_by}
                                        />
                                    </div>


                                </div>
                                <TaskHistory history={selectedTask?.historyTasks || []} />
                            </motion.div>
                        )}
                    </AnimatePresence>

                    {/* Overlay only on mobile */}
                    {selectedTask && (
                        <div
                            className="fixed inset-0 bg-black/30 z-40 md:hidden"
                            onClick={() => setSelectedTask(null)}
                        />
                    )}

                    {/* Overlay for mobile */}
                    {selectedTask && (
                        <div
                            className="fixed inset-0 bg-black/30 z-40 md:hidden"
                            onClick={() => setSelectedTask(null)}
                        />
                    )}

                </div>
            </div>

            <TaskModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} leadOptions={leadOptions} assignOptions={assignOptions} fetchTask={fetchTask} />
            <TaskModalEdit isOpen={isModalOpen1} setIsOpen={setIsModalOpen1} leadOptions={leadOptions} assignOptions={assignOptions} taskEdit={taskEdit} fetchTask={fetchTask} />
        </>
    );
};

export default Task;

const SortableTask = ({ task, handleCompleteTask, onEdit, onDelete, onView, onTogglePause }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: task.id });

    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [reason, setReason] = useState("");
    const [selectedReason, setSelectedReason] = useState("");
    const [customReason, setCustomReason] = useState("");

    const pauseReasons = [
        "Checked Out",
        "Team Meeting",
        "Lunch Break",
        "Tech Issue",
        "Client Wait",
        "Research Task",
        "Out Office",
        "Review Hold",
        "Different Project",
        "Other"
    ];

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    const handleConfirm = () => {
        console.log(`${modalType} reason for ${task.id}:`, reason);
        setModalOpen(false);
        setReason("");

        if (modalType === "pause") {
            onTogglePause(task.id, task.paused, selectedReason === "Other" ? customReason : selectedReason);
        }
    };





    return (
        <>
            <div
                ref={setNodeRef}
                style={style}
                {...attributes}
                className="flex items-start justify-between p-2 bg-gradient-to-r from-white/80 to-white/50 backdrop-blur-sm rounded-lg shadow-sm hover:shadow-md transition-all duration-300 border border-gray-200"
            >
                {/* Left side: Grip + Details */}
                <div className="flex gap-2 w-full">
                    <button
                        {...listeners}
                        className="cursor-grab active:cursor-grabbing text-gray-400 hover:text-gray-600 mt-1"
                        title="Drag to reorder"
                    >
                        <GripVertical size={16} />
                    </button>

                    <div className="flex flex-col gap-1 flex-grow">
                        <span
                            style={{
                                textDecoration: task.status === "Completed" ? "line-through" : "",
                                textDecorationColor: task.status === "Completed" ? "gray" : "inherit",
                            }}
                            className="font-semibold text-gray-900 text-xs"
                        >
                            {task.title}
                        </span>


                        <div className="flex items-center gap-2 text-xs">
                            <span
                                className={`px-2 py-0.5 rounded-full font-medium ${task.priority === "high"
                                    ? "bg-red-200 text-red-800"
                                    : task.priority === "medium"
                                        ? "bg-yellow-200 text-yellow-800"
                                        : "bg-green-200 text-green-800"
                                    }`}
                            >
                                {task.priority}
                            </span>
                            <div className="w-px h-3 bg-gray-300"></div>
                            <span className="text-gray-500 italic">{new Date(task.start_date).toLocaleDateString("en-GB")}</span>
                        </div>

                        {/* Eye, Edit, Delete */}
                        <div className="flex items-center gap-2 mt-1">
                            <button
                                className="p-1 hover:bg-gray-100 rounded-md transition"
                                onClick={() => onView(task)}
                                title="View Task"
                            >
                                <Eye size={14} className="text-gray-700" />
                            </button>
                            {
                                task.assigned_by === "Staff" && <button
                                    onClick={() => onEdit(task)}
                                    className="p-1 hover:bg-blue-100 rounded-md transition"
                                    title="Edit Task"
                                >
                                    <Pencil size={14} className="text-blue-600" />
                                </button>
                            }

                            <button
                                onClick={() => onDelete(task.id)}
                                className="p-1 hover:bg-red-100 rounded-md transition"
                                title="Delete Task"
                            >
                                <Trash2 size={14} className="text-red-600" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right side: Status Controls */}
                <div className="flex items-center gap-2 ml-2">
                    {
                        task.status !== "Completed" &&
                        (
                            !task?.paused ? (
                                <button

                                    className="p-1 hover:bg-green-100 rounded-md transition"
                                    title="Continue Task"
                                    onClick={() => onTogglePause(task.id, task.paused)}
                                >
                                    <Play size={16} className="text-green-600 w-5 h-5" />
                                </button>
                            ) : (
                                <button
                                    onClick={() => {
                                        setModalType("pause");
                                        setModalOpen(true);
                                    }}

                                    className="p-1 hover:bg-yellow-100 rounded-md transition"
                                    title="Pause Task"
                                >
                                    <Pause size={16} className="text-yellow-600 w-5 h-5" />
                                </button>
                            )
                        )
                    }


                    <button
                        onClick={() => handleCompleteTask(task.id, task.status)}
                        className="p-1 hover:bg-gray-100 rounded-md transition"
                        title={task.status === "Completed" ? "Mark as Completed" : "Mark as Incomplete"}
                    >
                        {task.status === "Completed" ? (
                            <CheckCircle className="w-5 h-5 text-green-600" />
                        ) : (
                            <Circle className="w-5 h-5 text-gray-400 hover:text-green-500" />
                        )}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {modalOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 flex items-center justify-center bg-black/40 z-50"
                    >
                        <div className="bg-white p-6 rounded-xl shadow-2xl w-96">
                            <h3 className="text-base font-semibold text-gray-900 mb-4">
                                {modalType === "pause" ? "Why pause this task?" : "Why stop this task?"}
                            </h3>

                            {/* Grid of reasons */}
                            <div className="grid grid-cols-3 gap-3">
                                {pauseReasons.map((reason, i) => (
                                    <label
                                        key={i}
                                        className={`cursor-pointer px-3 py-2 rounded-lg text-sm font-medium text-center shadow-sm transition 
                ${selectedReason === reason
                                                ? "bg-blue-600 text-white shadow-md"
                                                : "bg-gray-100 text-gray-700 hover:bg-gray-200"}`}
                                    >
                                        <input
                                            type="radio"
                                            name="reason"
                                            value={reason}
                                            checked={selectedReason === reason}
                                            onChange={() => setSelectedReason(reason)}
                                            className="hidden"
                                        />
                                        {reason}
                                    </label>
                                ))}
                            </div>

                            {/* Custom input when "Other" selected */}
                            {selectedReason === "Other" && (
                                <input
                                    type="text"
                                    value={customReason}
                                    onChange={(e) => setCustomReason(e.target.value)}
                                    placeholder="Enter custom reason..."
                                    className="mt-4 w-full border border-gray-300 rounded-md p-2 text-sm shadow-sm"
                                />
                            )}

                            {/* Footer buttons */}
                            <div className="flex justify-end gap-3 mt-6">
                                <button
                                    onClick={() => setModalOpen(false)}
                                    className="px-4 py-1.5 text-sm bg-gray-200 rounded-md hover:bg-gray-300"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() =>
                                        handleConfirm(selectedReason === "Other" ? customReason : selectedReason)
                                    }
                                    disabled={!selectedReason || (selectedReason === "Other" && !customReason)}
                                    className="px-4 py-1.5 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                                >
                                    Confirm
                                </button>
                            </div>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

        </>
    );
};



const EditableField = ({
    value,
    field,
    onChange,
    leadOptions = [],
    assignOptions = [],
    assignedBy, // 👈 New prop
}) => {
    const [editing, setEditing] = useState(false);
    const [temp, setTemp] = useState(value);

    // Prevent editing if assigned_by is Admin
    const isDisabled = assignedBy === "Admin";

    const handleBlur = () => {
        setEditing(false);
        if (temp !== value) {
            onChange(temp);
        } else {
            setTemp(value);
        }
    };

    const handleChange = (e) => {
        const newValue = e.target.value;
        setTemp(newValue);
        onChange(newValue);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setTemp(file.name);
            onChange(file);
        }
    };

    useEffect(() => {
        setTemp(value);
    }, [value]);

    const baseClass =
        "w-full bg-gray-50 border-b border-blue-400 outline-none px-1 py-0.5 rounded-sm text-[12px]";

    const renderInput = () => {
        switch (field) {
            case "due_date":
                return (
                    <input
                        type="date"
                        min={new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })}
                        className={baseClass}
                        value={
                            temp
                                ? new Date(temp).toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })
                                : ""
                        }
                        autoFocus
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                );

            case "priority":
            case "repetition":
            case "assign_to":
            case "list_id":
                return (
                    <select
                        className={baseClass}
                        value={temp}
                        autoFocus
                        onChange={(e) => setTemp(e.target.value)}
                        onBlur={handleBlur}
                    >
                        {field === "priority" && (
                            <>
                                <option value="high">High</option>
                                <option value="medium">Medium</option>
                                <option value="low">Low</option>
                            </>
                        )}
                        {field === "repetition" && (
                            <>
                                <option value="none">Does not repeat</option>
                                <option value="daily">Daily</option>
                                <option value="weekly">Weekly</option>
                                <option value="monthly">Monthly</option>
                                <option value="annually">Annually</option>
                            </>
                        )}
                        {field === "assign_to" &&
                            assignOptions.map((ele, idx) => (
                                <option key={idx} value={ele.value}>
                                    {ele.label}
                                </option>
                            ))}
                        {field === "list_id" &&
                            leadOptions.map((ele, idx) => (
                                <option key={idx} value={ele.value}>
                                    {ele.label}
                                </option>
                            ))}
                    </select>
                );

            case "notes":
                return (
                    <textarea
                        className={baseClass}
                        value={temp}
                        rows={2}
                        autoFocus
                        onChange={(e) => setTemp(e.target.value)}
                        onBlur={handleBlur}
                    />
                );

            case "attachment":
                if (editing) {
                    return (
                        <input type="file" className={baseClass} autoFocus onChange={handleFileChange} />
                    );
                } else {
                    return value ? (
                        typeof value === "string" ? (
                            <a
                                href={`${process.env.REACT_APP_LINK}/${value}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 underline text-xs"
                            >
                                View Attachment
                            </a>
                        ) : (
                            <span className="text-gray-700 text-xs">{value.name}</span>
                        )
                    ) : (
                        <span className="text-gray-400 italic text-xs">No file</span>
                    );
                }

            default:
                return (
                    <input
                        type="text"
                        className={baseClass}
                        value={temp}
                        autoFocus
                        onChange={(e) => setTemp(e.target.value)}
                        onBlur={handleBlur}
                    />
                );
        }
    };

    return (
        <div
            className={`w-full text-[12px] ${isDisabled ? "opacity-70 cursor-not-allowed" : "cursor-pointer"
                }`}
            onClick={() => !isDisabled && setEditing(true)}
            onMouseEnter={() => !isDisabled && !editing && setEditing(true)}
        >
            <AnimatePresence mode="wait">
                {editing && !isDisabled ? (
                    <motion.div
                        key="input"
                        initial={{ opacity: 0, y: -3 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 3 }}
                        transition={{ duration: 0.15, ease: "easeOut" }}
                    >
                        {renderInput()}
                    </motion.div>
                ) : (
                    <motion.p
                        key="text"
                        initial={{ opacity: 0, y: 3 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -3 }}
                        transition={{ duration: 0.15, ease: "easeOut" }}
                        className="text-gray-700 truncate text-[12px]"
                    >
                        {value || "—"}
                    </motion.p>
                )}
            </AnimatePresence>
        </div>
    );
};


